// extracted by mini-css-extract-plugin
export var legendIndicator = "_fh-1";
export var legendRight = "_fh-0";